import React from 'react';
import { ClientPanelCard } from './HeroSection';
export function MobileClientPanel() {
  return <section className="md:hidden" style={{
    background: '#f0ecf8',
    padding: '0 24px 40px'
  }} data-id="element-304">
      <div style={{
      maxWidth: '440px',
      margin: '0 auto'
    }} data-id="element-305">
        <ClientPanelCard showNotification={true} data-id="element-306" />
      </div>
    </section>;
}